import { render, staticRenderFns } from "./ResellerPage.vue?vue&type=template&id=7fab1000&scoped=true&lang=html&"
import script from "./ResellerPage.vue?vue&type=script&lang=js&"
export * from "./ResellerPage.vue?vue&type=script&lang=js&"
import style0 from "./ResellerPage.vue?vue&type=style&index=0&id=7fab1000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab1000",
  null
  
)

export default component.exports